import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import CKEditor from "react-ckeditor-component";
import Multiselect from "multiselect-react-dropdown";
import {
  getSubCategoriesList,
  getCategories,
  getStateList
} from "../../redux/actions/indexActions";
import { toast } from "react-toastify";

const AddPlace = () => {
  const [searchParams] = useSearchParams();
  const partnerId = searchParams.get('partnerId');
  
  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_id: "",
    sub_sub_category_id: "",
    state_id: "",
    city_id: 0,
    town_id: 0,
    place_name: "",
    latitude: 0,
    longitude: 0,
    map_url: "",
    amount: 0,
    description: "",
    short_description: "",
    featured: 0,
    status: 1,
    place_image: "",
    courseCategory: [],
    courseSubCategory: [],
    courseSubSubCategory: [],
    course_category_id: "",
    course_sub_category_id: "",
    courseSubCategoryId: "",
    courseSubSubCategoryId: "",
    partner_id: partnerId || "",
  });
  const [errors, setErrors] = useState({});
  const [cities, setCities] = useState([]);
  const [towns, setTowns] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [text, setText] = useState([]);
  const [courseCategory, setCourseCategory] = useState([]);
  const [courseCategoryOption, setCourseCategoryOption] = useState([]);
  const [courseSubCategory, setCourseSubCategory] = useState([]);
  const [courseSubCategoryOption, setCourseSubCategoryOption] = useState([]);
  const [courseSubSubCategory, setCourseSubSubCategory] = useState([]);
  const [courseSubSubCategoryOption, setCourseSubSubCategoryOption] = useState([]);
  const {
    AuthReducer: { auth },
    indexReducer: { categoriesList, subCategoriesList, stateLists }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "place_image") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {

    axios
      .get(`/api/admin/v1/categories`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then((res) => {
        // setCourseCategory([])
        setCourseCategoryOption(
          res.data.categories.map((item) => ({ name: item.name, id: item.id }))
        );
      })
      .catch((err) => console.error(err));

  }, []);

  const handleCourseCategoryChange = (val) => {
    if (val.length) {
      axios.get(`/api/admin/v1/sub-category-list?id=${val.map(it => it.id).join(',')}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`
        }
      })
        .then((({ data }) => {
          setCourseSubCategory(prev => prev.filter((item) => val.find(it => it.id === item.id)))
          setCourseSubCategoryOption(data.data.map((item) => {
            return { name: item.title_english, id: item.id, category_id: item.category_id }
          }))
        }))
        .catch((err) => console.log(err))
    } else {
      setCourseSubCategory([])
      setCourseSubCategoryOption([]);
    }
  }
  const handlePaymentTypeChange = (e) => {
    setFormData({
      ...formData,
      type: e.target.value
    })
  };
  const handleCourseSubCategoryChange = (val) => {
    if (val.length) {
      axios.get(`/api/admin/v1/sub-sub-category-list?category_id=${val.map(item => item.category_id).join(',')}&sub_category_id=${val.map(it => it.id).join(',')}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`
        }
      })
        .then((({ data }) => setCourseSubSubCategoryOption(data.data.map((item) => {
          return { name: item.title_english, id: item.id, category_id: item.category_id, sub_category_id: item.sub_category_id }
        }))))
        .catch((err) => console.log(err))
    } else {
      setCourseSubSubCategory([])
      setCourseSubSubCategoryOption([])
    }
  }


  console.log(towns, 'fsf')
  const handleSubmit = () => {
    const form = new FormData();
    form.append('category_id', JSON.stringify(courseCategory));
    form.append('sub_category_id', JSON.stringify(courseSubCategory));
    form.append('sub_sub_category_id', JSON.stringify(courseSubSubCategory));
    form.append('state_id', formData.state_id)
    form.append('city_id', formData.city_id)
    form.append('town_id', formData.town_id)
    form.append('place_name', formData.place_name)
    form.append('latitude', formData.latitude)
    form.append('longitude', formData.longitude)
    form.append('map_url', formData.map_url)
    form.append('amount', formData.amount)
    form.append('short_description', formData.short_description)
    form.append('place_image', formData.place_image)
    form.append('description', text)
    form.append("featured", formData.featured)
    form.append("status", formData.status)
    if (partnerId) {
      form.append('partner_id', partnerId)
    }
    axios
      .post(`/api/admin/v1/add-place`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

  const handleText = (e) => {
    const descriptions = e.editor.getData();
    setText(descriptions);
  }


  useEffect(() => {
    dispatch(getStateList(auth.token));
    dispatch(getCategories(auth.token));
  }, [auth]);

  useEffect(() => {
    if (formData?.category_id) {
      axios(`/api/admin/v1/get-subcategory-by-category/${formData?.category_id}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubCategoryList(data?.subCategoriesbyCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [formData?.category_id]);

  useEffect(() => {
    if (formData?.sub_category_id) {
      axios(`/api/admin/v1/get-subsubcategory-by-subcategory/${formData?.sub_category_id}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubSubCategoryList(data?.subSubCategoriesbySubCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubSubCategoryList([]);
    }
  }, [formData?.sub_category_id]);

  useEffect(() => {
    if (formData.state_id) {
      setFormData((prev) => ({ ...prev, city_id: 0 }));
      axios(`/api/admin/v1/get-city/${formData.state_id}`)
        .then(({ data }) => {
          console.log(data, 'date');
          setCities(data?.data);
        })
        .catch((err) => console.error(err));
    } else {
      setCities([]);
    }
  }, [formData.state_id]);
  console.log(formData.city_id, 'formData.city_id ')
  useEffect(() => {
    if (formData.state_id && formData.city_id) {
      // setFormData((prev) => ({ ...prev, town_id: 0 }));
      axios(`/api/admin/v1/get-town/${formData.state_id}/${formData.city_id}`)
        .then(({ data }) => {
          console.log(data?.data, 'date');
          setTowns(data?.data);
        })
        .catch((err) => console.error(err));
    } else {
      setTowns([]);
    }
  }, [formData?.state_id, formData?.city_id]);
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Place</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label> Category</Label>
              <Multiselect className="text-black"
                options={courseCategoryOption}
                displayValue="name"
                selectedValues={courseCategory}
                onSelect={(val) => {
                  setCourseCategory([...val])
                  handleCourseCategoryChange(val)
                }}
                onRemove={(val => {
                  setCourseCategory([...val])
                  handleCourseCategoryChange(val)
                })}
                labelledBy="Select"
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label> Sub Category</Label>
              <Multiselect className="text-black"
                options={courseSubCategoryOption}
                displayValue="name"
                selectedValues={courseSubCategory}
                onSelect={(val) => {
                  setCourseSubCategory([...val])
                  handleCourseSubCategoryChange(val)
                }}
                onRemove={(val => {
                  setCourseSubCategory([...val])
                  handleCourseSubCategoryChange(val)
                })}
                labelledBy="Select"
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Sub Sub Category</Label>
              <Multiselect className="text-black"
                options={courseSubSubCategoryOption}
                selectedValues={courseSubSubCategory}
                displayValue="name"
                onSelect={(val) => {
                  setCourseSubSubCategory(val)
                }}
                onRemove={(val) => setCourseSubSubCategory([...val])}
                labelledBy="Select"
              />
            </FormGroup>
          </div>


          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.state_id}
                type="select"
                name="state_id"
                onChange={inputHandler}
              >
                <option value="">Select</option>
                {stateLists?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.state_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.state_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>City </Label>
              <Input value={formData?.city_id} type="select" name="city_id" onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}>
                <option value="">Select</option>
                {cities?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.city_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.city_id}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Town</Label>
              <Input invalid={Boolean(errors?.town_id)} value={formData?.town_id} type="select" name="town_id" onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}>
                <option value="">Select</option>
                {towns?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.town_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.town_id}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.place_name)} value={formData?.place_name} name="place_name" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.place_name} </span>
            </FormGroup>
          </div>


          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Featured</Label>
              <Input value={formData?.featured} name="featured" onChange={inputHandler} />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Image</Label>
              <Input type="file" invalid={Boolean(errors?.place_image)} name="place_image" onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.files[0],
                }))
              }
              />
              <span className="d-block text-danger">{errors?.place_image}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Description <span className="text-danger fs-4">*</span></Label>
              <Input name="short_description" value={formData?.short_description} type="textarea" onChange={inputHandler} />
              <span className="d-block text-danger">{errors?.short_description}</span>
            </FormGroup>
          </div>
          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Full Description</Label>
              <CKEditor content={text} events={{ "change": handleText }} />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Latitude </Label>
              <Input invalid={Boolean(errors?.latitude)} value={formData?.latitude} name="latitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.latitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Longitude </Label>
              <Input invalid={Boolean(errors?.longitude)} value={formData?.longitude} name="longitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.longitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Map_url</Label>
              <Input invalid={Boolean(errors?.map_url)} value={formData?.map_url} name="map_url" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.map_url} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input type="switch" checked={formData?.status} onChange={inputHandler} name="status" />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPlace;
